import { render, staticRenderFns } from "./MakeFeedSoccerJoin.vue?vue&type=template&id=23e2de82&scoped=true&"
import script from "./MakeFeedSoccerJoin.vue?vue&type=script&lang=js&"
export * from "./MakeFeedSoccerJoin.vue?vue&type=script&lang=js&"
import style0 from "./MakeFeedSoccerJoin.vue?vue&type=style&index=0&id=23e2de82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e2de82",
  null
  
)

export default component.exports